import React, { useState } from 'react';
import KreasikanData from './../assets/images/kreasikan_data.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faSpinner } from '@fortawesome/free-solid-svg-icons';
import './../css/premiummodal.scss';
import { API_REQUEST_PREMIUM } from '../api/api';
import $ from 'jquery';
import { useHistory } from 'react-router';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { useDispatch, useSelector } from 'react-redux';
import { clickUpgradePremium } from '../services/amplitude';
import axios from 'axios';

export const PremiumExpiration = () => {
  const dispatch = useDispatch();
  const { isNotified } = useSelector((state) => state.user);
  const { currentPage } = useSelector((state) => state.amplitude);

  const history = useHistory();
  const MySwal = withReactContent(Swal);

  const [loading, setLoading] = useState(false);

  const distance = Number(localStorage.getItem('distance'));

  const onRequestPremium = () => {
    setLoading(true);
    axios.post(API_REQUEST_PREMIUM.premium(localStorage.getItem('id')), undefined, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then(() => {
        $('#modal-premium').modal('hide');
        $('#modal-success-request-premium').modal('toggle');
      })
      .catch((err) => {
        MySwal.fire({
          icon: 'error',
          text: `${err.response.data.message}`,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const confirmNotified = () => {
    dispatch({
      type: 'NOTIFY_USER_EXPIRATION',
      payload: true,
    });
  };

  return (
    <div
      className="modal fade premium-modal"
      id="modal-premium"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div className="modal-dialog" style={{ width: 400 }} role="document">
        <div className="modal-content">
          <div className="d-flex justify-content-end pt-3 pr-3 text-danger">
            {distance <= 0 && (
              <button
                onClick={() => {
                  history.replace({ pathname: '/', state: { pageChannel: currentPage } });
                }}
                style={{
                  borderRadius: '50%',
                  width: 25,
                  height: 25,
                  outline: 'none',
                  border: 'none',
                  backgroundColor: 'red',
                  color: 'white',
                }}
                data-dismiss="modal"
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            )}
          </div>
          {distance <= 0 && (
            <div className="modal-body text-center">
              <h5>Tingkatkan Akun ke Premium</h5>
              <img style={{ width: '100%', height: 220 }} src={KreasikanData} />
              <p className="px-3 text-center mt-2" style={{ fontSize: 17 }}>
                Nikmati seluruh fitur MAP selama satu bulan tanpa biaya tambahan
              </p>
              <button
                disabled={loading}
                onClick={() => {
                  onRequestPremium();
                  clickUpgradePremium(currentPage);
                }}
                className="btn btn-overview-green-solid w-75"
              >
                {loading ? <FontAwesomeIcon spin style={{ fontSize: 20 }} icon={faSpinner} /> : 'Tingkatkan Sekarang'}
              </button>
            </div>
          )}
          {!isNotified && distance <= 7 && distance > 0 && (
            <div className="modal-body text-center">
              <h5>
                Masa Premium anda tersisa <strong>{distance}</strong> hari
              </h5>
              <img style={{ width: '100%', height: 220 }} src={KreasikanData} />
              <p>Anda masih dapat menikmati fitur premium dalam {distance} hari ke depan.</p>
              <button
                className="btn btn-overview-green-solid w-75"
                data-dismiss="modal"
                onClick={() => confirmNotified()}
              >
                Saya Mengerti
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PremiumExpiration;
